import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {
  constructor() {}

  setCustomError(control: AbstractControl | null, message: string): void {
    if (control) {
      control.setErrors({ ...control.errors, custom: message });
    }
  }
}
